import React, { useState } from 'react';

const CollapsibleSummary = ({ children, handleOpen, id, style }) => {
  
  return (
    <div onClick={handleOpen} data-id={id.toString()} style={style}>
    {children}
    </div>
  )};

const CollapsibleContent = ({ detailsHidden, children, ...props }) => {
  return (
    <div>
      {children}
    </div>
  )
}; 

const Collapsible = ({ children }) => {
  const [open, setOpen ] = useState("");
  const handleOpen = (e) => {
    const id = e.target.getAttribute("data-id");
    console.log("Collapsible.id: "+id);
    id === open ? setOpen("") : setOpen(id);
  }
  return (
    <div>
      {React.Children.map(children, (child, i) => 
      { 
        const id = child.props.children[0].props.id;
        const summary = React.cloneElement(child.props.children[0], {
          handleOpen,
          id
        });
        const content = child.props.children[1];
        return (
          <div>
            {summary}
            {id === open && content}
          </div>
        )
      })}
    </div>
  )
};

Collapsible.Item = ({children}) => children;
Collapsible.Summary = CollapsibleSummary;
Collapsible.Content = CollapsibleContent;

export default Collapsible;